import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  overflow: {
    overflow: 'visible',
  },
  dialog: {
    '& h6': {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontSize: '19px',
      lineHeight: '23px',
      letterSpacing: 0,
      paddingTop: 6,
      paddingBottom: 0,
    },
    '& label': {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: 0,
      paddingBottom: 8,
      color: '#4A4A4A',
    },
    '& .MuiInput-input': {
      paddingBottom: 16,
    },
    '& .MuiGrid-item': {
      paddingTop: 6,
      paddingBottom: 6,
    },
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      marginTop: '10px',
      marginBottom: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#bbb',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa',
    },
    borderRadius: '10px',
    dialogContent: {
      paddingTop: 24,
      paddingBottom: 24,
      paddingLeft: 40,
      paddingRight: 40,
      borderBottom: 'none',
    },
    title: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      fontSize: '0.9em',
      color: '#212121',
      lineHeight: '1.4em',
    },
    subtitle: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      fontSize: '17px',
      color: '#212121',
      lineHeight: '1em',
    },
    dialogTitle: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: '19px',
      lineHeight: '23px',
      letterSpacing: 0,
    },
    actionsContainer: {
      paddingRight: 40,
      paddingLeft: 40,
      paddingBottom: 40,
      paddingTop: 20,
    },
    actionsButton: {
      borderRadius: '10px',
      fontSize: '16px',
      fontWeight: 400,
      fontFamily: 'Arial',
      lineHeight: '18.4px',
      letterSpacing: 0,
      padding: '16px 45px',
    },
  },
}))

export { useStyles }
